import React from "react";
import { ArrowUpRight, Building2, Mountain, Factory } from "lucide-react";

const SERVICES = [
  {
    icon: Building2,
    nr: "01",
    title: "Hochbau",
    image: "https://images.pexels.com/photos/18162494/pexels-photo-18162494.jpeg",
    desc: "Wohn-, Gewerbe- und öffentliche Bauten — vom Rohbau bis zur schlüsselfertigen Übergabe.",
    points: ["Schlüsselfertigbau", "Stahlbetonbau", "Sanierung & Umbau", "Anbau", "Aufstockungen"],
  },
  {
    icon: Mountain,
    nr: "02",
    title: "Tiefbau",
    image: "https://images.pexels.com/photos/21033111/pexels-photo-21033111.jpeg",
    desc: "Erdarbeiten, Kanalbau und Infrastruktur — solide Fundamente für Stadt und Industrie.",
    points: ["Erd- & Aushubarbeiten", "Kanal- & Rohrleitungsbau", "Straßen- & Wegebau", "Spezialtiefbau"],
  },
  {
    icon: Factory,
    nr: "03",
    title: "Industriebau",
    image: "https://images.pexels.com/photos/236709/pexels-photo-236709.jpeg",
    desc: "Hallen, Produktionsstätten und Logistikzentren — funktional, robust, termintreu.",
    points: ["Industriehallen", "Logistikzentren", "Produktionsgebäude", "Brandschutzkonzepte"],
  },
];

export default function Leistungen() {
  return (
    <section
      id="leistungen"
      data-testid="leistungen-section"
      className="bg-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="w-12 h-px bg-red-600" />
              <span className="text-xs font-bold uppercase tracking-[0.3em] text-red-600">
                Leistungen
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-black uppercase tracking-tighter text-zinc-900 max-w-2xl leading-[0.95]">
              Drei Disziplinen.<br />
              <span className="text-zinc-400">Ein Anspruch.</span>
            </h2>
          </div>
          <p className="text-base sm:text-lg text-zinc-600 max-w-md font-light">
            Wir vereinen klassisches Bauhandwerk mit modernster Technik. Jedes Projekt — vom
            Einfamilienhaus bis zur Industriehalle — wird mit derselben Sorgfalt geplant und umgesetzt.
          </p>
        </div>

        {/* Services grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 border border-zinc-200">
          {SERVICES.map((s, idx) => {
            const Icon = s.icon;
            return (
              <article
                key={s.title}
                data-testid={`service-card-${s.title.toLowerCase()}`}
                className={`group relative bg-white p-8 md:p-10 flex flex-col ${
                  idx !== 2 ? "md:border-r border-zinc-200" : ""
                } ${idx !== 0 ? "border-t md:border-t-0 border-zinc-200" : ""} hover:bg-zinc-950 transition-colors duration-500`}
              >
                {/* Image */}
                <div className="relative aspect-[4/3] overflow-hidden mb-8 bg-zinc-100">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute top-4 left-4 bg-white text-zinc-900 px-3 py-1 text-xs font-bold tracking-widest">
                    {s.nr}
                  </div>
                </div>

                {/* Title */}
                <div className="flex items-center gap-3 mb-4">
                  <Icon className="w-6 h-6 text-red-600 transition-colors group-hover:text-red-500" />
                  <h3 className="font-display text-2xl md:text-3xl font-bold uppercase tracking-tight text-zinc-900 group-hover:text-white transition-colors">
                    {s.title}
                  </h3>
                </div>

                <p className="text-zinc-600 group-hover:text-zinc-300 transition-colors mb-6 flex-1">
                  {s.desc}
                </p>

                <ul className="space-y-2 mb-8">
                  {s.points.map((p) => (
                    <li
                      key={p}
                      className="flex items-center gap-3 text-sm text-zinc-700 group-hover:text-zinc-200 transition-colors"
                    >
                      <span className="w-1.5 h-1.5 bg-red-600" />
                      {p}
                    </li>
                  ))}
                </ul>

                <a
                  href="#kontakt"
                  data-testid={`service-cta-${s.title.toLowerCase()}`}
                  className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-widest text-zinc-900 group-hover:text-red-500 transition-colors"
                >
                  Anfrage stellen
                  <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </a>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
